export default "/assets/images/mila-feed-10-thumbnail.95844bf13c782a37.jpg";